(function () {
  'use strict';

  /* @ngdoc object
   * @name appFileDownload
   * @description
   *
   */
  angular
    .module('appFileDownload', [
      'ui.router'
    ]);
}());
